import gql from "graphql-tag";

export default gql`
	mutation trialExchange($requestAccessToken: String!) {
		exchangeTrial(requestAccessToken: $requestAccessToken) {
			... on ExchangeTrialSuccess {
				trialId
				token
				refreshToken
			}
			... on ExchangeTrialFailure {
				errorCode
				message
			}
		}
	}
`;

export const readTrialExchangeResult = ({ data }) =>
	data && {
		...data.exchangeTrial,
	};
